import AbnormalReportAllFilter from '@/pages/dashboard/filterPageComponents/report/abnormalReportAllFilter';
import AbnormalReportIframeCo from '@/pages/dashboard/pages/abnormalReport/components/AbnormalReportIframeCo';
import AbnormalReportDownloadBtn from '@/pages/dashboard/pages/abnormalReport/components/AbnormalReportDownloadBtn';

export default {
  AbnormalReportAllFilter,
  AbnormalReportIframeCo,
  AbnormalReportDownloadBtn,
};
